/*
 * Product translations for the "en" locale.
 *
 * Split out of locales/en.js so product pages stop shipping their copy to
 * every route in the app. Keys keep their original names minus the
 * "products_" prefix. See locales/products/index.js.
 */
export default {
  shopiing_page: {
    cover: {
      title1: "Consumer Finance",
      title2: "We Make Your Life Easier",
      description: `Contact makes your life easier anytime you want to buy anything via financial solutions without any troubles. Contact makes your life easier anytime you want to buy anything via financial solutions without any troubles`,
    },
    outro:
      "Contact is more than just a financing company. We are your trusted partner in fulfilling your shopping needs. We enable you to own what you dream of, without any hassle or stress. Contact us today, establish your account, and start enjoying the easiest shopping experience ever. ",
    section_a: {
      title1: "Payment Period",
      title2: "36 Months",
      body: "Enjoy your purchasing experience with our hassle-free financial solutions, fast approval process, and the widest merchant network for consumer products & services. Choose your installment plan from 6 to 60 months and pay at your convenience through the most diverse payment and collection network across Egypt.",
    },
    section_b: {
      title: "How Does It Work? ",
      description:
        "It's simple. When you already have an open account with Contact, you can just ",
      list: [
        "Choose your merchant from our network",
        "Go to the store with the national ID and mobile registered in the service",
        "Choose your payment plan ",
        "You will receive an OTP code via SMS to provide to the cashier",
        "An electronic invoice will be sent via SMS",
      ],
    },
  },
  contact_now_page: {
    cover: {
      img: "/shopping-main.png",
      title: `Shopping for your favourite items is only one click away!`,
      description: `Explore our Online shopping Financing Solutions, or visit the nearest Contact Branch where our team will be ready to assist you. `,
    },
    main_section: {
      titleLine1: "Shopping",
      titleLine2: "Financing",
      mainImage: "/shopping-main.png",
      header: "Roll Your Shopping Cart Forward with Contact Now Financing ",
      description: "",
      paragraph2: `Get the products you’ve been dreaming of, whether it’s the latest electronics, a new smartphone, a high-definition TV, or essential items for your home, and enjoy a seamless online shopping experience like never before. With online shopping payment plans and flexible shopping payments, Contact makes it easy to manage your purchases without straining your budget.
Our service allows you to buy now and pay later with complete ease and convenience, giving you the freedom to get what you need today while spreading your payments over time. 
`,
      buttonText: "Apply Now",
      subtitle:
        "Contact ensures your shopping experience is smooth, secure, and tailored to your lifestyle",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/girl_shopping.webp",
      title: "Manage Your Bills Easily with Fatorty",
      paragraph: `Pay any recent bill in simple, stress-free installments with Fatorty. Just <a href="https://play.google.com/store/apps/details?id=eg.contact" style="color: inherit; text-decoration: underline;">download the app</a>, choose the payment period that suits you, and enjoy the most flexible bill payment options available. With Fatorty, handling your bills has never been easier or more convenient`,
      list: [],
    },
    offers_steps: {
      title: "Discover Exclusive Offers During Your Shopping Experience",
      subtitle:
        "Unlock amazing deals with ContactNow App in just a few simple steps:",
      steps: [
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-1.png",
          content: "Open the Contact App.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-2-en.webp",
          content:
            "Search for your favorite merchant or visit the Offers section.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-3-en.webp",
          content: "Select the offer you want.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-4-en.webp",
          content: "Enter the required information.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-5-en.webp",
          content: "The merchant reviews your details on their portal.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-6-en.webp",
          content: "Visit the merchant branch and wait for their approval.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-7.webp",
          content: "You will receive an OTP on your phone.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-8-en.webp",
          content: "Once the OTP is confirmed, the transaction is completed.",
        },
      ],
    },
    third_section: {
      title: "Shop Smarter with Contact!",
      description: `With Contact, you can buy any consumer product you want, whether it’s a laptop, mobile phone, TV, or anything else, and pay later through flexible installment plans with fast approval. We offer the widest network of merchants across Egypt, so you can find all the products and services you’re looking for in one place. Contact isn’t just a financing company; we’re a partner that makes it easier for you to get what you need without stress. Open your account now and enjoy the easiest and fastest shopping and financing experience.
`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/shopping-third.png",
    },
    why_product: {
      title: "Your Journey to Easy Registration",
      subtitle: "",
      description: "Becoming a ContactNow client is simple and fast:",

      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/boy_shopping.webp",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",

          text: `Download the <a href="https://play.google.com/store/apps/details?id=eg.contact" style="color: blue;">ContactNow </a> App`,
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "Create your account and complete the registration",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "You’ll receive a limit decision",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "If approved, visit the nearest Contact branch within 30 days to sign your contract",
        },
      ],
      note: "Once signed, you’re officially a Contact client and ready to enjoy all the benefits!",
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "Why should I do my shopping with ContactNow?",
          a: `
        <p>Using ContactNow makes your shopping experience easier and more manageable. Here are just a few of the benefits:</p>
        <ul style="margin-top: 10px;">
          <li>You can apply for instant credit approval.</li>
          <li>We offer financing up to 1 million EGP for any product or service you need.</li>
          <li>You can choose payment plans that fit your budget, lasting up to 5 years.</li>
          <li>Get started with easy and fast transactions and no down payment</li>
          <li>You get access to a wide network of merchants, covering all categories.</li>
          <li>No hidden fees or charges.</li>
          <li>Flexible and convenient payment options.</li>
          <li>A professional and friendly customer service team is available to help you 24/7.</li>
        </ul>
      `,
        },
        {
          q: "What documents do I need to finance my shopping with Contact?",
          a: `
          <p>If you already have an open account with Contact, just make sure you bring your National ID and have the mobile phone that is registered with the service when you visit the store.
</p>
      `,
        },
        {
          q: "How can I use Contact’s Buy Now Pay Later service?",
          a: `
          <p>Here’s how you can buy what you want today and pay later in easy installments:</p>
        <ol style="margin-top: 10px;">
          <li>Choose your merchant from our wide network.</li>
          <li>Go to the store with your National ID and the mobile number registered in the service.</li>
          <li>Choose your preferred payment plan.</li>
          <li>You will receive an OTP (One-Time Password) via SMS to provide to the cashier.</li>
          <li>An electronic invoice will then be sent to you via SMS.</li>  
        </ol>
      `,
        },
        {
          q: "What kind of items can I purchase using these flexible shopping payments?",
          a: `
    <p>Our Shopping Financing covers just about everything! Whether you want to buy a new laptop, jewelry, cosmetics, a smartphone, a TV, or any other consumer product, our wide merchant network covers all categories and brands to help you get the products and services you need all over Egypt.</p>
    `,
        },
        {
          q: "What if I have questions or need help with my online shopping payment plans?",
          a: `
          <p>We are always here to help! Our professional and friendly customer service team is at your service 24/7 to support you. You can reach us anytime on our hotline at 16177 or visit the nearest <a href="https://contact.eg/en/our-branches">branch</a> to you.</p>
      `,
        },
      ],
    },
    section_a: {
      title1: "Payment Period",
      title2: "36 Months",
      body: "Enjoy your purchasing experience with our hassle-free financial solutions, fast approval process, and the widest merchant network for consumer products & services. Choose your installment plan from 6 to 60 months and pay at your convenience through the most diverse payment and collection network across Egypt.",
    },
    section_b: [
      "Choose your merchant from our network",
      "Go to the store with the national ID and mobile registered in the service",
      "Choose your payment plan ",
      "You will receive an OTP code via SMS to provide to the cashier",
      "An electronic invoice will be sent via SMS",
    ],
  },
  finishing: {
    id: 43,
    cover: {
      img: "/home-interior-main.png",
      color: "#95664B",
      title: `Your Splash of Paint awaits! 
Immerse in our Home Interior Financing now`,
      description: `You can apply online or visit the nearest Contact branch.`,
    },
    price: "Home Interior Cost",
    main_section: {
      titleLine1: "Home Interior",
      titleLine2: "Financing",
      mainImage: "/home-interior-main.png",
      header: "Renovate Your Dream Home with Contact’s Interior Financing ",
      description: "",
      paragraph2: `Turn your home into a masterpiece that truly reflects your style and personality. With home interior financing from Contact, you can bring your dream spaces to life, hire top interior design experts in Egypt, and enjoy flexible solutions like home design payment plans, remodeling financing, decor payment options, and interior project financing. Let Contact help you color your home with comfort and style, making your renovation journey smooth, affordable,and with a pop of color.`,
      buttonText: "Apply Now",
      subtitle: "Immerse in our Home Interior Financing now",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-interior-second.png",
      title: "Transform Your Home with Flexible Interior Financing",
      paragraph: `Turn your ideal home style into reality with Home Interior Financing from Contact. Choose your preferred interior design company, and we’ll provide the support to fund your renovation. Enjoy payment plans up to 5 years, financing up to 4 million EGP, and down payments starting from just 20%, all through simple and fast procedures. 
Apply now, set up your account with Contact, and get ready to live in the style you’ve always imagined.
`,
      list: [],
    },
    third_section: {
      title: "Easy Financing for Your Home Makeover with Contact",
      description: `At Contact, we simplify remodeling financing, interior project financing, and flexible decor payment options to suit your needs. With our online Calculator, you can quickly estimate your installments, compare different financing plans, and choose the one that fits your budget. Take control of your home renovation with confidence, knowing that Contact makes the process easier and more convenient. Start with our Online Calculator today and bring your dream interiors to life!`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-interior-third.png",
    },

    why_product: {
      title: "",
      description: `Enjoy the benefits of flexible and easy financing that lets you finish and design your home exactly the way you like it with complete ease.`,
      imageSrc: "",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Payment plans up to 5 years",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "Financing up to 4 million EGP",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "Down-payments starting from 20%",
        },
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "Why should I choose financing home interiors with Contact?",
          a: `
          <p>Home interior financing with Contact comes with many benefits to make your dream home a reality, stress-free!</p>
        <ul style="margin-top: 10px;">
          <li>Flexible home design payment plans that extend to 5 years.</li>
          <li>Generous financing up to 6 million EGP.</li>
          <li>Affordable down payment starting from just 20%.</li>
          <li>Simple and fast procedures so you can begin your project sooner.</li>
          <li>Freedom to pick the interior design company you love</li>
        </ul>
      `,
        },
        {
          q: "How do I apply for Home Interior financing with Contact?",
          a: `
          <p>Applying is simple, and you can do it your way!</p>
      <strong>Option 1: Apply Online</strong>
      <ul style="margin-top: 10px;">
        <li>Go to the Contact Home Interior Financing page.</li>
        <li><strong>Fill out the short form:</strong> Just share your full name, mobile number, and national ID.</li>
        <li><strong>Get a personal callback:</strong> A Contact representative will call to confirm your details and request any supporting documents if needed.</li>
        <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
        <li><strong>Choose your payment plan:</strong> Select the installment plan that works best for you.</li>
        <li><strong>Track and pay your installments:</strong> Use <a href="https://api.whatsapp.com/send/?phone=20216177">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
      </ul>
      <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">
    Visit your nearest branch, and our team will guide you through the process!
<a href="https://contact.eg/en/our-branches">Find a branch near you</a>.
   </p>
    `,
        },
        {
          q: "What can I finance through Contact’s Home Interior Financing?",
          a: `
          <p>Our home interior financing covers the full scope of your home transformation. Whether you're looking for complete remodeling financing for a big overhaul or flexible decor payment options for finishing touches. We provide the interior project financing you need to bring your unique vision to life!</p>
      `,
        },
        {
          q: "Do I have to use a specific interior design company?",
          a: `
          <p>Not at all! We believe in giving you the freedom to create your perfect space. You can pick any interior design company you prefer, and Contact will finance your home renovation project with them.</p>
      `,
        },
      ],
    },

    outro:
      "Home Interior and Finishing Financing is a partnership with a shared purpose, reaching your dreams and goals. Pick the interior design company of your choice and Contact will finance your home renovation. Don't let your favorite home design remain a dream. Make it a reality with Home Interior and finishing financing from Contact. Apply now, establish your account with Contact, and get ready to enjoy your new home style. ",
    section_a: {
      title: "4,000,000 EGP",
      body: `lorem ipsum dolor sit amet, consectetur adip non pro id, sed diam nonum vulputate velit sed diam nonum. 
    Ut enim ad minim veniam, quis nostr arranged eu fugiat null a ante et d.`,
    },
    section_b: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "Without Advance",
      body: `lorem ipsum dolor sit amet, consectetur adip non pro id, sed diam nonum vulputate velit sed diam nonum. 
    Ut enim ad minim veniam, quis nostr arranged eu fugiat null a ante et d.`,
    },
  },
  home_furniture: {
    id: 58,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-furniture.png",
      color: "#5E7EB5",
      title: "You are one step closer to a whole home upgrade!",
      description: ` Discover our home furniture financing options or visit the nearest Contact branch to enjoy a fast, smooth, and affordable process.`,
    },
    price: "Furniture Cost ",
    main_section: {
      titleLine1: "Home Furniture",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-furniture.png",
      header:
        "Furnish your home in style with Contact’s Home Furniture Financing ",
      description: "",
      paragraph2: `If you’re ready to refresh your home with modern furniture while staying within your budget, Contact has the perfect solution. With our flexible furniture payment plans, you can elevate your home’s style, upgrade your spaces, and achieve your goals, all without financial pressure.`,
      buttonText: "Apply Now",
      subtitle: "Your home upgrade awaits!",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-second.png",
      title: "Flexible Furniture Financing Tailored to Your Home Needs",
      paragraph: `At Contact, we dedicate all our efforts to provide unique payment plans and financing options tailored to your wants and needs. Whether you’re looking for affordable furniture financing or living room financing, we offer flexible furniture payments so that you can purchase your favorite piece of furniture in Egypt with ease. Don’t hold back on your home upgrade, discover our payment plans, choose what suits you best and let us handle the rest. 
`,
      list: [],
    },
    third_section: {
      title: "Why Choose Contact for Furniture Payment Plans?",
      subtitle: "",
      description: `At Contact, we make furnishing your home easier and more accessible than ever. With payment plans of up to 5 years, you can spread out your expenses comfortably, without feeling the financial strain all at once. We offer financing of up to 3 million EGP, giving you the flexibility to choose the furniture and designs that truly match your vision, whether it’s a full home makeover or a single standout piece.
Getting started is simple, with down payments starting from just 20%, so you can secure your furniture without a large upfront cost. Our fast and straightforward procedures ensure a smooth experience from the moment you apply to the final delivery, saving you time and effort.
With these flexible and convenient solutions, you can furnish your home exactly the way you’ve always imagined, stress-free and fully supported.
`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/third-sec-home.png",
    },

    why_product: {
      title: "",
      subtitle: "",
      description: `Enjoy the benefits of flexible and easy financing that lets you furnish your home exactly to your taste with complete ease.`,
      imageSrc: "",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Payment plans up to 5 years",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "Financing up to 3 million EGP",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "Down-payments starting from 20%",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: "The ability to combine different quotations in the same request",
        },
      ],
    },

    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What benefits do I get when financing home furniture with Contact?",
          a: `
          <p>Choosing us for your home furniture financing comes with great advantages that'll help you create your dream space easily:</p>
      <ul style="margin-top: 10px;">
  <li>Flexible furniture payment plans available for up to 5 years.</li>
  <li>Generous financing up to 3 million EGP to cover all your furniture needs.</li>
  <li>Accessible down payments starting from just 20%.</li>
  <li>Quick, simple, and straightforward procedures.</li>
  <li>Combine multiple quotations from different stores into one single financing request.</li>
</ul>

      `,
        },
        {
          q: "How do I apply for home furniture financing with Contact?",
          a: `
          <p>Applying is simple, and you can do it your way!</p>
      <strong>Option 1: Apply Online</strong>
      <ul style="margin-top: 10px;">
        <li>Go to the Contact Home Furniture Financing page.</li>
        <li><strong>Fill out the short form:</strong> Just share your full name, mobile number, and national ID.</li>
        <li><strong>Get a personal callback:</strong> A Contact representative will call to confirm your details and request any supporting documents if needed.</li>
        <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
        <li><strong>Choose your payment plan:</strong> Select the installment plan that works best for you.</li>
        <li><strong>Track and pay your installments:</strong> Use <a href="https://api.whatsapp.com/send/?phone=20216177">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
      </ul>
      <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">
    Visit your nearest branch, and our team will guide you through the process!
<a href="https://contact.eg/en/our-branches">Find a branch near you</a>.
   </p>
    `,
        },
        {
          q: " What if I have questions or need assistance with my payment plans or application?",
          a: `
          <p>We're always here to help! You can reach us anytime on our hotline at 16177, send us a message on <a href="https://api.whatsapp.com/send/?phone=20216177">WhatsApp</a>, or email us at Info@contact.eg.</p>
          `,
        },
        {
          q: "Do I have to buy from a specific store to get financing?",
          a: `
        <p>Not at all! You are not restricted to just one store. You can get quotations from your preferred furniture stores. Our service even allows you to combine different quotations into one single request.</p>
      `,
        },
      ],
    },
    outro:
      "If you’re looking to purchase furniture in Egypt, Contact offers a variety of financing services and programs that can help you achieve your goals. With Contact’s Home Furniture Financing service, you can easily and affordably refresh your home style. ",
  },
  manasik: {
    id: 57,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/3d-airplane.png",
      color: "#547865",
      title: "Ready to embark on the most significant life experience?",
      description:
        "Apply online today or visit the nearest Contact Branch, and let us guide you through!",
    },
    price: "Trip Price",
    section_2: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/manasik_section_2.webp",
      description:
        "Our flexible payment plans for both Hajj and Umrah are tailored to your needs, ensuring that you can focus on fulfilling this sacred duty without worrying about upfront expenses. Whether it’s your first time or a cherished return visit, Contact is here to support you every step of the way",
    },
    section_3: {
      title: "With Manasik you get:",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/manasik_section_3.webp",
      list: [
        "Shariah Compliance:Financing solutions aligned with Islamic principles.",
        "Flexible Payment Plans:Spread the cost of your journey over manageable installments.",
        "Quick Approvals:Start your preparation immediately with our hassle-free process.",
        "Dedicated Support:Our team is here to guide you through financing and planning your trip.",
      ],
    },
    section_4: {
      description:
        "Don’t let financial concerns delay your journey. With Contact, your path to the Holy Land is just a step away. Embrace the opportunity to perform Hajj or Umrah with peace of mind and a full heart. Start your sacred journey today with Manasik by Contact.",
    },

    main_section: {
      titleLine1: "Travel & Tourism",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/3d-airplane.png",
      header:
        "Travel Your Way with Contact’s Travel and Tourism Installment plans",
      description: "",
      paragraph2: `Whether you're dreaming of a relaxing vacation, an exciting adventure, or a well-deserved family getaway, Contact helps you turn your travel plans into reality. Our Travel & Tourism financing solutions are designed to give you the flexibility to book your trip today and pay comfortably over time.
From local escapes to international journeys, you can choose the destination, experience, and package that suit your lifestyle, while we take care of making it affordable.
`,
      buttonText: "Apply Now",
      subtitle: "Your next destination is just a click away",
    },

    product_program_1: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/internal-travel.webp",
      title: `Weekend Getaways 
      & Short Trips`,
      paragraph: `Need a quick break? Plan a short trip to the North Coast, Ain Sokhna, Luxor, Aswan, or any destination you love. 
      Enjoy a refreshing weekend without worrying about upfront costs. With flexible payment plans, your next escape is closer than you think.`,
      list: [],
    },

    product_program_2: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/europe-travel.webp",
      title: "International Travel Packages",
      paragraph: `Discover the world with curated travel packages to Europe, Asia, the Gulf, or anywhere on your bucket list. 
      Whether it’s sightseeing, shopping, or cultural exploration, Contact helps you finance your international trip with ease.
`,
      list: [],
    },

    product_program_3: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/family-travel.webp",
      title: "Family Vacations",
      paragraph: `Create unforgettable memories with your family through organized trips designed for comfort and fun. 
      From beach resorts to city tours and theme parks, finance your family vacation and enjoy quality time together,  stress-free.`,
      list: [],
    },

    product_program_4: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/third-section-manasik.png",
      title: `Hajj and Umrah 
      Financing Plans`,
      paragraph: `Set foot into a worthwhile experience. 
Wish to follow your dream of completing hajj and umrah?
Now at Contact, whether you want to apply for a Hajj loan or a Umrah installment plan, we’re here to facilitate the process. 
We don’t stop here; we also provide Travel and Tourism Financing for your next spiritual journey ahead. 
Inner peace is at your fingertips.<a href="#apply-form" style="color: inherit; text-decoration: underline;"> Apply online</a> with contact.`,
      list: [],
    },

    section_title_1: {
      title: "Your Trusted Partner For the Perfect Honeymoon Destination",
      description: `Experience the joy of travelling with your loved one with an unforgettable honeymoon tailored to your dreams. Whether you’re planning a serene beach escape, a romantic European getaway, or an adventurous international trip, Contact helps make it possible.`,
      paragraph2: `With financing solutions specially designed for newlyweds, you can explore the world together without worrying about your budget. Focus on creating beautiful memories with your partner, while we take care of making your dream honeymoon within reach. <a href="#apply-form" style="color: inherit; text-decoration: underline;"> Apply online</a> today, and let Contact handle your dream honeymoon.`,
    },

    section_title_2: {
      title:
        "Complete Umrah & Hajj with Contact’s Travel and Tourism Financing",
      description: `At Contact, our goal is to provide you with a true sense of fulfillment this upcoming Hajj season without the burden of upfront costs.
As one of the leading Hajj financing companies, we offer a variety of Islamic Shariah-compliant Hajj and Umrah packages, including flexible Umrah package installments, making it easier for you to perform your pilgrimage.
`,
      paragraph2: `Whether you're exploring the cost of Hajj from Egypt in installments, looking for convenient Umrah financing,or wish to travel on a holiday with your loved ones, we’ve got you covered with ease, flexibility, and peace of mind.
`,
    },

    why_product: {
      title: "The Travel and Tourism Coverage Benefits",
      description:
        "Experience a seamless journey with exclusive benefits tailored to your sacred travel needs:",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/manasik-travel.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Flexible Payment Plans.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/approval-icon.svg",
          text: "Quick Approvals.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/support-icon.svg",
          text: "Dedicated Support.",
        },
      ],
    },

    why_contact: {
      title: "Why Choose Contact For Your Hajj Loan?",
      subtitle: "",
      description: `It’s a once-in-a-lifetime deal! 
With Contact’s unique financing solutions, your pilgrimage will be smooth and stress-free.
Enjoy financing benefits like:
`,
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: "Payment plans up to 5 years for Hajj and 12 months for Umrah.",
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-white-icon.svg",
          text: "Financing packages up to 3 million EGP.",
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Analytics.svg",
          text: "Down payment starting from 20%.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Pocedures.svg",
          text: "Simple and fast procedures.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/transactions-icon.svg",
          text: "Transactions compliant with the Islamic Shariah. ",
        },
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What types of trips can I finance through Contact?",
          a: `
    <p>You can finance a wide range of travel experiences, including local weekend getaways, international travel packages, family vacations, honeymoons, as well as Hajj and Umrah trips.</p>
  `,
        },

        {
          q: "How much financing can I get?",
          a: `
    <p>Financing amounts can reach up to 3 million EGP for Hajj and up to 1 million EGP for other travel and tourism trips, depending on your eligibility and the trip details.</p>
  `,
        },

        {
          q: "What is the minimum down payment?",
          a: `
    <p>Down payments start from 20%, making it easier to book your trip without paying the full amount upfront.</p>
  `,
        },

        {
          q: "What are the available repayment periods?",
          a: `
    <p>Repayment plans are flexible:</p>

    <ul style="margin-top: 10px;">
      <li>Up to 5 years for Hajj</li>
      <li>Up to 12 months for Umrah</li>
      <li>Up to 3 years for touristic trips</li>
    </ul>
  `,
        },

        {
          q: "Can I finance my honeymoon through Contact?",
          a: `
    <p>Absolutely. Contact provides tailored financing solutions for newlyweds, helping you plan your dream honeymoon with flexible payment options.</p>
  `,
        },

        {
          q: "How can I finance Hajj or Umrah costs with Contact?",
          a: `
      <p>Applying is simple, and you can do it your way!</p>
    <strong>Option 1: Apply Online</strong>
    <ul style="margin-top: 10px;">
      <li>Go to the Contact Travel and Tourism Financing page</li>
      <li><strong>Fill out a short form:</strong> Just share your full name, mobile number, and national ID.</li>
      <li><strong>Get a personal callback:</strong> A Contact rep will call to confirm your details and request any supporting documents if needed.</li>
      <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
      <li><strong>Choose your payment plan: </strong>Select the installment plan that works best for you.</li>
      <li><stron>Track and pay your installments: </stron> Use <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
    </ul>
    <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">Visit your nearest branch, and our team will guide you through the process! <a href="https://contact.eg/en/our-branches">Find a branch near you.</a></p>`,
        },

        {
          q: " What are the conditions for financing Hajj and Umrah Packages from Contact?",
          a: `<p>Our Hajj and Umrah financing conditions are designed to make your sacred journey easier and more accessible:</p>
           <strong>Eligibility Requirements</strong>
          <ul style="margin-top: 10px;">
          <li>Egyptian citizenship/residency: A valid national ID is required.</li>
          <li>Age: Open to adults between 21 and 65 years old</li>
          </ul>

           <strong>Financial Terms</strong>
          <ul style="margin-top: 10px;">
          <li>Down payment: Minimum 20% of your total package cost.</li>
          <li>Financing limit: Up to EGP 3 million (covers flights, accommodation, and visas).</li>
          </ul>
          `,
        },

        {
          q: "Is there a special program for financing Umrah only through Contact?",
          a: `<p>Yes! Our dedicated Contact Umrah financing program offers:</p>
          <ul style="margin-top: 10px;">
          <li>Installments up to 12 months</li>
          <li>Down payments starting from 20%</li>
          <li>Financing up to EGP 3 million</li>
          <li>Transactions fully compliant with the Islamic Shariah</li>
          </ul>
          <p>Whether it’s Umrah or Hajj, Contact is here to support every step of your spiritual journey.</p>`,
        },

        {
          q: "What documents are required to apply for Hajj and Umrah Financing from Contact?",
          a: `
          <p>Gathering your Hajj or Umrah financing documents is simple! Here’s all you’ll need:</p>
    <ul style="margin-top: 10px;">
      <li><strong>Your Egyptian ID:</strong> National ID card or passport.</li>
      <li><strong>Signed quotation from your travel agency.</strong></li>
    </ul>
    <p>Our team may request additional information depending on the type of installment. <a href="https://contact.eg/en/contact-us">Feel free to contact us</a>, we’re happy to guide you through the exact requirements and next steps!</p>
  `,
        },
      ],
    },
  },
  factoring: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/factoring-cover.webp",
      color: "#BF6340",
      title1: "Factoring",
      title2: "The easiest cash solution",
      description: `Factoring is a simple and convenient way to access working capital without taking on debt or giving up equity. You can use the cash to pay your suppliers, employees, and taxes, or invest in new projects. Factoring also helps you reduce your credit risk, as Contact assumes the responsibility of collecting the payments from your customers.Contact is a leading provider of Factoring services in Egypt, with a proven track record of empowering businesses across various industries. Whether you are a small or medium enterprise, a large corporation, or a multinational company, Contact can offer you customized and flexible solutions that suit your needs and goals.`,
    },
    outro:
      "If you need to know more about how Contact can help you grow your business with Factoring, contact us today.",
  },
  clubs: {
    id: 44,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubMain.png",
      color: "#282781",
      title: "Ready to hit the club?",
      description: `Apply online today or visit the nearest Contact Branch.`,
    },
    price: "Financing Amount",
    main_section: {
      titleLine1: "Club MemberShip",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubMain.png",
      header: "Join The Club with Contact’s Club Installment Plans!",
      description: "",
      paragraph2: ` Whether you’re on the lookout for a sports club, social club, Contact makes it easier than ever to become part of the community.
        With flexible Club Membership and Sports Club Loan options, you can unlock access to the experiences you’ve always wanted for yourself and your family.`,
      buttonText: "Apply Now",
      subtitle: "Closer to a better living",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/supportClub.png",
      title: "Own Your Club Membership In Egypt With Contact.",
      paragraph: `Unlock the lifestyle you deserve with Contact, Egypt’s leading financing company.
Now you can finance your club membership in Egypt easily and affordably, whether you're aiming for a premium sports club membership or a vibrant social club. Join the club you've always dreamed of, and give your family the community they deserve.`,
      list: [],
    },
    why_product: {
      title: "Contact’s Sports Club Loan Benefits",
      subtitle: "",
      description:
        "Get tailored financing solutions that fit your lifestyle and goals: ",

      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/whyContactClub.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fast.svg",
          text: "Fast and simple procedures.",
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",
          text: "Flexible payment plans.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feesClubIcon.svg",
          text: "Coverage for club membership fees across Egypt.",
        },
      ],
    },
    why_contact: {
      title: "Why Choose Contact For Your Club Membership Loan?",
      subtitle: "",
      description:
        "Step into the lifestyle you’ve always wanted with unmatched ease and flexibility from Contact:",

      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: "Payment plans up to 5 years.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-white-icon.svg",

          text: "Financing up to 1.5 million EGP.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: "No down payment. Simple and fast procedures.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/SimpleHassleIcon.svg",
          text: "Instant Membership Activation.",
        },
      ],
    },

    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "How do I apply for a Club Membership loan with Contact?",
          a: `
          <p>Applying is simple, and you can do it your way!</p>
      <strong>Option 1: Apply Online</strong>
      <ol style="margin-top: 10px;">
        <li>Go to the Contact Club Membership Financing page.</li>
        <li><strong>Fill out the short form:</strong> Just share your full name, mobile number, and national ID.</li>
        <li><strong>Get a personal callback:</strong> A Contact representative will call to confirm your details and request any supporting documents if needed.</li>
        <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
        <li><strong>Choose your payment plan:</strong> Select the installment plan that works best for you.</li>
        <li><strong>Track and pay your installments:</strong> Use WhatsApp or the ContactNow App to manage everything from home.</li>
      </ol>
      <strong>Option 2: Apply In Person</strong>
      <p style="margin-top: 10px;">
        Visit your nearest Contact branch, and our team will guide you through the process.
      <a href="https://contact.eg/en/our-branches">Find a branch near you</a> .
      </p>
      `,
        },
        {
          q: "What types of club memberships can I finance with Contact?",
          a: `
          <p>You can finance memberships at sports clubs, social clubs, across Egypt. Whether you're looking to support your child’s athletic talent or want to enjoy a more active lifestyle yourself, our Club Membership loans have you covered with flexible payment plans and no down payments!</p>
      `,
        },
        {
          q: "What are the benefits of financing my club membership installment plans with Contact?",
          a: `
     <p>Whether it’s a sports club loan or financing for a cultural or social club, we’re here to make your dream of joining your favorite club happen quickly and easily! Our club installment plans offer:</p>
      <ul style="margin-top: 10px;">
        <li>Financing up to EGP 1.5 million</li>
        <li>No down payment required</li>
        <li>Flexible repayment terms up to 5 years</li>
        <li>A simple and fast approval process, whether you apply online or at a <a href="https://contact.eg/en/our-branches">branch</a></li>
        <li>Instant membership activation, so you can start enjoying your new club right away</li>
      </ul>
      `,
        },
        {
          q: "Do I need to pay anything upfront to join a club using Contact’s financing?",
          a: `
Not at all!  With Contact Club Membership Financing, you pay in convenient monthly installments over a period of up to 5 years, with amounts of up to EGP 1.5 million, and absolutely no down payment!      `,
        },
      ],
    },

    outro:
      "Don't miss the opportunity to join your favorite club and achieve your dreams and happiness. Apply now with Contact and get approved in minutes. ",
    clubs_title: "Subscribed Clubs",
    clubs: [
      [
        "Wadi Degla Club",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club1.png",
      ],
      [
        "Matrix Club",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club2.png",
      ],
      [
        "Zohor Club",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club3.png",
      ],
      [
        "Island Club",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club4.png",
      ],
      [
        "Hawar Club",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club5.png",
      ],
      [
        "Platinum Club",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club6.png",
      ],
    ],
  },
  maintainance: {
    id: 59,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintenance.png",
      color: "#DB8539",
      title: "Maintenance financing just got easier ",
      description: `Explore your maintenance financing options today or visit the nearest Contact branch to get started!`,
    },
    price: "Maintenance Price",
    main_section: {
      titleLine1: "Maintenance",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintenance.png",
      header: "Maintenance Made Easier With Contact",
      description: "",
      paragraph2: `Managing repairs, whether it’s vehicle maintenance, home repair, or property upkeep, can often be costly and stressful. Contact simplifies it all with innovative service payment plans, offering vehicle maintenance financing, home repair financing, and flexible maintenance payment options tailored to your needs. With Contact Maintenance Financing, you can hire top maintenance experts in Egypt and pay later with ease and confidence`,
      buttonText: "Apply Now",
      subtitle: "Explore your maintenance financing options today",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintenance-second.png",
      title: "Calculate your installments",
      paragraph: `At Contact, we make financing simple, transparent, and tailored to your needs. With our Online Calculator, you can easily estimate your installments and explore all available financing options at your own pace. Find the plan that fits you best, manage your payments with confidence, and enjoy the peace of mind that comes from being covered by Contact. Try our online calculator today and take the first step toward hassle-free financing!
`,
      list: [],
    },
    why_product: {
      title: "Why Choose Contact For Maintenance Financing ?",
      description:
        "Managing maintenance projects can be costly and time-consuming, but Contact makes it easy and affordable. Our tailored financing solutions are designed to give you the flexibility, support, and speed you need to solve any difficulties without stress.",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintenance-third.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Flexible Plans up to 24 Months",
          desc: "Enjoy extended, hassle-free payment plans tailored to your budget.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "Financing Up to 1.5 Million EGP",
          desc: " Get the support you need for any maintenance project, big or small.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",
          text: "Down Payments Starting from Just 20%",
          desc: "Affordable entry options that help you get started right away.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fast.svg",
          text: "Fast & Simple Procedures",
          desc: " Quick approvals and smooth steps to keep your maintenance uninterrupted.",
        },
      ],
    },

    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What are the benefits of financing maintenance with Contact?",
          a: `
          <p>Contact makes financing your maintenance projects simple and affordable. Benefits include:</p>
      <ul style="margin-top: 10px;">
  <li>Flexible service payment plans stretching up to 24 months.</li>
  <li>Access to financing up to 1.5 million EGP to cover significant repairs or renovations.</li>
  <li>Manageable down payment starting from just 20%.</li>
  <li>Straightforward and fast application procedures.</li>
</ul>

      `,
        },
        {
          q: "How do I apply for maintenance financing with Contact?",
          a: `
          <p>Applying is simple, and you can do it your way!</p>
      <strong>Option 1: Apply Online</strong>
      <ul style="margin-top: 10px;">
        <li>Go to the Contact Maintenance Financing page.</li>
        <li><strong>Fill out the short form:</strong> Just share your full name, mobile number, and national ID.</li>
        <li><strong>Get a personal callback:</strong> A Contact representative will call to confirm your details and request any supporting documents if needed.</li>
        <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
        <li><strong>Choose your payment plan:</strong> Select the installment plan that works best for you.</li>
        <li><strong>Track and pay your installments:</strong> Use <a href="https://api.whatsapp.com/send/?phone=20216177">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
      </ul>
      <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">
    Visit your nearest branch, and our team will guide you through the process!
<a href="https://contact.eg/en/our-branches">Find a branch near you</a>.
   </p>
    `,
        },
        {
          q: "Can I choose my own maintenance professional or service center?",
          a: `
          <p>Absolutely! Our goal is to help you get the repairs you need from the professionals and service centers you trust. You can choose your preferred provider for vehicle maintenance financing or home repair financing, and we'll provide the flexible maintenance payments to cover the cost!</p>
          `,
        },
        {
          q: "What can I finance through Contact’s Maintenance Financing?",
          a: `
          <p>At Contact, we cover vehicle maintenance financing, home repair financing, and property improvement financing to get your car back in top shape, your home ready for renovations, or your property looking its best. 

If it's a maintenance project you’re after, we have a solution for you!
</p>
      `,
        },
        {
          q: "What documents do I need to apply for maintenance financing with Contact?",
          a: `To start, you'll only need a valid National ID ready. Depending on the financing amount and your profile, we might also request simple supporting documents like proof of income or residence to finalize your maintenance financing application.
`,
        },
      ],
    },
    outro:
      "If you are looking for a reliable and affordable way to finance your maintenance projects, look no further than Contact. Establish your account today with Contact and enjoy exclusive benefits and programs.",
  },
  trucks: {
    id: 32,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/truck-cover.png",
      title: "Your Truck Awaits! Flexible financing, simple procedures.",
      description:
        "Explore our truck Financing Solutions, and start your journey with Contact!",
    },
    price: "Truck Price",
    main_section: {
      titleLine1: "Truck",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/truck-cover.png",
      header: "Explore Flexible Truck Financing solutions with Contact",
      description: "",
      paragraph2: `Keep your engine moving with Contact! Our truck financing and commercial truck financing solutions are designed to support businesses of every size. Whether you’re expanding your operations or upgrading your vehicles, we provide fast, simple procedures and flexible semi-truck payment plans and vehicle financing solutions tailored to your needs. Contact offers financing for all types of heavy transport and trucks, including small, mid-sized, and heavy trucks, as well as semi-trailers, flatbeds, step decks, and more. With options for new, used, and imported vehicles, we make it easier than ever to keep your fleet moving.
Explore our truck Financing Solutions, or visit the nearest branch and let our team handle the rest. `,
      buttonText: "Apply Now",
      subtitle: "Explore our truck Financing Solutions",
    },

    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/second-section-truck.png",
      title: `Why Choose Contact for 
      Truck Financing?`,
      paragraph: `At Contact, we go beyond our clients’ expectations. Our flexible truck financing solutions and payment plans are designed with your convenience in mind. Enjoy payment plans of up to 5 years and coverage of up to 8 million Egyptian pounds. With down payments starting at just 20%, we ensure fast and simple procedures that keep your fleet moving and leave you fully satisfied. Visit our website or explore the nearest branch to you, where our team is ready to assist.`,
      list: [],
    },

    plans_steps: {
      title: `Discover Our 
Truck Installment Plans`,
      steps: [
        {
          name: "New Trucks - Standard",
          role: [
            "30% Down Payment",
            "Payment Plans up to 4 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 1 month and a half",
          ],
        },
        {
          name: "New Trucks - Flexible",
          role: [
            "20% Down Payment",
            "Payment Plans up to 5 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
        {
          name: "Imported Trucks - Standard",
          role: [
            "30% Down Payment",
            "Payment Plans up to 4 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 1 month and a half",
          ],
        },
        {
          name: "Imported Trucks - Economy",
          role: [
            "50% Down Payment",
            "Payment Plans up to 4 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 1 month and a half",
          ],
        },
        {
          name: "Imported Trucks - Economy Plus",
          role: [
            "50% Down Payment",
            "Payment Plans up to 5 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
        {
          name: "Imported Trucks - Flexible",
          role: [
            "20% Down Payment",
            "Payment Plans up to 5 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
        {
          name: "Used Trucks - Economy",
          role: [
            "50% Down Payment",
            "Payment Plans up to 4 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
        {
          name: "Used Trucks - Economy Plus",
          role: [
            "50% Down Payment",
            "Payment Plans up to 5 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
      ],
    },

    business_plans_steps: {
      title: `Unlock Flexible Truck 
Installment Plans for Businesses`,
      steps: [
        {
          name: "New Trucks - Standard",
          role: [
            "30% Down Payment",
            "Payment Plans up to 4 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 1 month and a half",
          ],
        },
        {
          name: "New Trucks - Flexible",
          role: [
            "30% Down Payment",
            "Payment Plans up to 5 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
        {
          name: "Imported Trucks - Standard",
          role: [
            "30% Down Payment",
            "Payment Plans up to 4 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 1 month and a half",
          ],
        },
        {
          name: "Imported Trucks - Economy",
          role: [
            "30% Down Payment",
            "Payment Plans up to 4 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 1 month and a half",
          ],
        },
        {
          name: "Imported Trucks - Economy Plus",
          role: [
            "30% Down Payment",
            "Payment Plans up to 5 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
        {
          name: "Imported Trucks - Flexible",
          role: [
            "30% Down Payment",
            "Payment Plans up to 5 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
        {
          name: "Used Trucks - Economy",
          role: [
            "30% Down Payment",
            "Payment Plans up to 4 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
        {
          name: "Used Trucks - Economy Plus",
          role: [
            "30% Down Payment",
            "Payment Plans up to 5 years",
            "Full or Partial Prepayment Options",
            "Insurance is not required",
            "First Installment after 2 months and a half",
          ],
        },
      ],
    },

    why_product: {
      title: "",
      subtitle: " ",
      description: `Enjoy the benefits of flexible and easy financing that lets you buy all types of heavy-duty transport vehicles and trucks you’ve always wanted with complete ease.`,
      imageSrc: "",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Payment plans up to 5 years",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "Financing up to 8 million EGP",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "Down-payments starting from 20%",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/id-card-icon.svg",
          text: "all types of heavy transport and trucks; small, mid-sized, heavy trucks. semi-trailers, flatbeds, step decks trucks, and more",
        },
      ],
    },

    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What types of trucks can I finance with Contact?",
          a: `<p>You can finance almost any type of heavy transport vehicle with Contact. from small and mid-sized trucks to heavy-duty trucks, semi-trailers, and flatbeds. We also offer commercial truck financing for new, used, and imported trucks.</p>
          `,
        },

        {
          q: "Why should I finance my truck with Contact?",
          a: ` <p>Because Contact provides you with comfort and flexibility at every step, through:</p>
          <ul style="margin-top: 10px;">
          <li>Flexible semi-truck payment plans with terms up to 5 years.</li>
          <li>Financing up to EGP 8 million to support small and large operations alike.</li>
          <li>Down payments starting from 20% to keep your cash flow steady.</li>
          <li>Fast and simple procedures to get your truck on the road quickly.</li>
          <li>No insurance required, with the option for full or partial prepayment at any time.</li>
          </ul>
          <p>Whether you’re upgrading your fleet or buying your first truck, our vehicle financing solutions are designed to make the process easy and affordable.</p>`,
        },
        {
          q: "How do I apply for truck financing with Contact?",
          a: `
      <p>Applying is simple, and you can do it your way!</p>
    <strong>Option 1: Apply Online</strong>
    <ul style="margin-top: 10px;">
      <li>Go to the Contact Truck Financing page</li>
      <li><strong>Fill out a short form:</strong> Just share your full name, mobile number, and national ID.</li>
      <li><strong>Get a personal callback:</strong> A Contact rep will call to confirm your details and request any supporting documents if needed.</li>
      <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
      <li><strong>Choose your payment plan: </strong>Select the installment plan that works best for you.</li>
      <li><stron>Track and pay your installments: </stron> Use <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
    </ul>
    <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">Visit your nearest branch, and our team will guide you through the process! <a href="https://contact.eg/en/our-branches">Find a branch near you.</a></p>`,
        },

        {
          q: "What documents are needed to apply for truck financing from Contact?",
          a: `
          <p>For the initial online form, we'll just need your full name, mobile number, and national ID to get started. Our team will let you know exactly what supporting documents are needed for your specific commercial truck financing application.</p>`,
        },
        {
          q: "Can I finance a used or imported truck with Contact?",
          a: `
          <p>Absolutely! Our commercial truck financing options cover used and imported vehicles, with various choices to suit your budget. You can choose from economy or flexible plans, adjust your down payment, and select repayment terms that best suit your needs</p>`,
        },
        {
          q: "How do installment plans for professionals and business activities work?",
          a: `
      <p>If you have a commercial register and tax card, you can access exclusive installment plans for professionals and business owners. Our plans are ideal for companies in industries like construction, manufacturing, logistics, or shipping.</p>
    <p>Here’s what you can expect:</p>
    <ul style="margin-top: 10px;">
    <li>Down payments starting at 30%.</li>
    <li>Payment plans up to 5 years, depending on the truck type.</li>
    <li>Full or partial prepayment flexibility.</li>
    <li>No insurance requirement.
</li>
    </ul>`,
        },
      ],
    },

    outro:
      "If you are involved in the Construction Industry, Manufacturing and Industrial Sector, or Shipping and Logistics in Egypt and deal with heavy cargo looking for a reliable financing option for your heavy equipment and trucks, Contact is here to help. We offer financing plans for all types of new, used, and imported trucks with easy and flexible procedures. ",
    plans_title: "Trucks Installments Plans",
    plans: [
      {
        name: "New Trucks - Standard",
        role: [
          "30% down payment",
          "Payment plans up to 4 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 1 month and half",
        ],
      },
      {
        name: "New Trucks - Flexible",
        role: [
          "20% down payment",
          "Payment plans up to 5 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
      {
        name: "Imported Trucks – Standard",
        role: [
          "30% down payment",
          "Payment plans up to 4 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 1 month and half",
        ],
      },
      {
        name: "Imported Trucks – Economy",
        role: [
          "50% down payment",
          "Payment plans up to 4 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 1 month and half",
        ],
      },
      {
        name: "Imported Trucks – Economy Plus",
        role: [
          "50% down payment",
          "Payment plans up to 5 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
      {
        name: "Imported Trucks – Flexible",
        role: [
          "20% down payment",
          "Payment plans up to 5 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
      {
        name: "Used Trucks – Economy",
        role: [
          "50% down payment",
          "Payment plans up to 4 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
      {
        name: "Used Trucks – Economy Plus",
        role: [
          "50% down payment",
          "Payment plans up to 5 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
    ],
    business_plans_title:
      "Installment Plans for Professionals & Business Activities (Commercial register & tax card)",
    business_plans: [
      {
        name: "New Trucks - Standard",
        role: [
          "30% down payment",
          "Payment plans up to 4 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 1 month and half",
        ],
      },
      {
        name: "New Trucks - Flexible",
        role: [
          "30% down payment",
          "Payment plans up to 5 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
      {
        name: "Imported Trucks – Standard",
        role: [
          "30% down payment",
          "Payment plans up to 4 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 1 month and half",
        ],
      },
      {
        name: "Imported Trucks – Economy",
        role: [
          "30% down payment",
          "Payment plans up to 4 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 1 month and half",
        ],
      },
      {
        name: "Imported Trucks – Economy Plus",
        role: [
          "30% down payment",
          "Payment plans up to 5 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
      {
        name: "Imported Trucks – Flexible",
        role: [
          "30% down payment",
          "Payment plans up to 5 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
      {
        name: "Used Trucks – Economy",
        role: [
          "30% down payment",
          "Payment plans up to 4 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
      {
        name: "Used Trucks – Economy Plus",
        role: [
          "30% down payment",
          "Payment plans up to 5 years",
          "Full or partial prepayment options",
          "Insurance is not required",
          "First installment after 2 months and half",
        ],
      },
    ],
  },
  cars: {
    id: 37,

    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/auto-main.png",
      color: "#282780",
      title: "Ready to get behind the wheel?",
      description: `Apply online or visit Contact’s Branch.`,
    },
    price: "Car Price",
    main_section: {
      titleLine1: "Auto",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/auto-main.png",
      header: "Buckle your seatbelts and rule the road!",
      description: "",
      paragraph2: `
        From sleek new models to reliable used vehicles, electric or fuel-powered, Contact offers flexible financing solutions tailored to your needs.
        Enjoy a seamless application process and customized installment plans with 25 years of expertise in car financing in Egypt, all at your fingertips.`,
      buttonText: "Apply Now",
      subtitle: "Drive the car you’ve always wanted with ease and confidence.",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/second-section-auto.png",
      title: "Get your New Car Loan Today",
      paragraph: `Looking to buy a new car or finance a used car, whether electric or fuel-powered?
Contact Car Loan solutions are designed to give you maximum flexibility and peace of mind.
With our wide range of installment plans and simple, streamlined procedures, owning your dream vehicle of any brand or model has never been easier.
You can even plan your payments using ourcar loan calculatorto find what works best for your budget.
With a nationwide network across major car showrooms, Contact is your trusted partner for new car loans, used car financing, backed by 25 years of expertise in car financing.
`,
      list: [],
    },
    why_product: {
      title: "Own Your Dream Car with Contact’s Car Installment Plans",
      subtitle: " ",
      description: `Enjoy the benefits of flexible and easy financing that lets you drive the car you’ve always wanted with complete ease: `,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/why-auto.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Payment plans up to 5 years",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "Financing up to 15 million EGP",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "Down-payments starting from 10%",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: "Optional Insurance",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/id-card-icon.svg",
          text: "Car licensing support service available (Licensing follow-up, renewal procedures on behalf of the customer) at no additional cost",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/expertise-icon.svg",
          text: "Additional services such as registration, insurance, and license renewal",
        },
      ],
    },
    third_section: {
      title: "Get instant approval for your car right away with Contact!",
      subtitle: "",
      description: `Get on the road faster with Contact, where convenience meets speed. You can now secure car approval in only a few minutes, saving you time and hassle. Our process is designed to be quick, simple, and stress-free, so you can focus on what really matters, enjoying the drive ahead. Whether you’re buying your first car or upgrading to your next, Contact makes it easier than ever to turn your plans into motion. Because with us, your time truly matters.`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/third-sec-auto.png",
    },
    why_contact: {
      title: "Why choose Contact For Auto Financing?",
      subtitle: ``,
      description: `Simple and reliable, here’s why Contact is Egypt’s trusted auto financing partner.`,
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/process-icon.svg",
          text: "Facilitated Process",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/team-icon.svg",
          text: "Dedicated Team",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/car-icon.svg",
          text: "25 years of expertise in car financing",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fast-icon.svg",
          text: "Simple and fast procedures",
        },
      ],
    },

    plans_steps: {
      title: "Installment Plans",
      steps: [
        {
          name: "Electric Vehicles",
          role: [
            "20% down payment",
            "Insurance is not required",
            "Payment plans up to 5 years",
            "Full or partial prepayment after 1 year",
          ],
        },
        {
          name: "New Plus",
          role: [
            "20% down payment",
            "Insurance required",
            "Payment plans up to 5 years",
            "First installment after 3 months",
          ],
        },
        {
          name: "Economy",
          role: [
            "20% down payment",
            "Insurance is required",
            "Payment plans up to 3 years",
          ],
        },
        {
          name: "Economy Plus",
          role: [
            "20% down payment",
            "Insurance is required",
            "Payment plans up to 5 years",
            "Full or partial prepayment after 1 year",
          ],
        },
        {
          name: "Flexible",
          role: [
            "20% down payment",
            "Insurance is required",
            "Payment plans from 3 to 5 years",
            "Full or partial prepayment after 1 year",
            "Partial deferral for down-payment",
          ],
        },
        {
          name: "Flexible Plus",
          role: [
            "20% down payment",
            "Insurance is not required",
            "Payment plans up to 5 years",
            "Full or partial prepayment options",
            "Partial deferral for down-payment",
          ],
        },
        {
          name: "Used Cars Packages",
          role: [
            "20% down payment",
            "Insurance is not required",
            "Payment plans up to 5 years",
          ],
        },
        {
          name: "Corporate Packages",
          role: [
            "10% down payment",
            "Insurance is required",
            "Payment plans from 2 to 5 years",
            "Full prepayment option after one year",
          ],
        },
        {
          name: "40% New",
          role: [
            "40% down payment",
            "Competitive interest rate",
            "Insurance is not required",
            "Payment plans up to 5 years",
            "Full prepayment option after one year",
          ],
        },
        {
          name: "40% Used",
          role: [
            "40% down payment",
            "Competitive interest rate",
            "Financing available for used car models up to 10 years old",
            "Eligible for cars with an odometer reading of up to 150,000 km",
            "Payment plans up to 5 years",
          ],
        },
      ],
    },

    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What are the conditions for car financing from Contact?",
          a: `
        <p>To qualify for car financing with Contact, you’ll only need to meet a few simple requirements:</p>
        <ul style="margin-top: 10px;">
          <li>Be between 21 and 65 years old</li>
          <li>Have a valid Egyptian National ID</li>
        </ul>
        <p>We keep it simple so you can focus on the road ahead!</p>
      `,
        },
        {
          q: "How do I apply for car financing with Contact?",
          a: `
          <p>Applying is simple, and you can do it your way!</p>
      <strong>Option 1: Apply Online</strong>
      <ul style="margin-top: 10px;">
        <li>Go to the Contact Auto Financing page.</li>
        <li><strong>Fill out the short form:</strong> Just share your full name, mobile number, and national ID.</li>
        <li><strong>Get a personal callback:</strong> A Contact representative will call to confirm your details and request any supporting documents if needed.</li>
        <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
        <li><strong>Choose your payment plan:</strong> Select the installment plan that works best for you.</li>
        <li><strong>Track and pay your installments:</strong> Use <a href="https://api.whatsapp.com/send/?phone=20216177">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
      </ul>
      <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">
    Visit your nearest branch, and our team will guide you through the process!
<a href="https://contact.eg/en/our-branches">Find a branch near you</a>.
   </p>
    `,
        },
        {
          q: "Can I finance a car with Contact using only my ID card?",
          a: `
        <p>Yes! With Contact, you can start your application and get instant approval in just a few minutes using only your National ID.</p>
        <p>Our support team is ready to guide you. Call 16177 anytime.</p>
      `,
        },
        {
          q: "Can I finance a used car with Contact?",
          a: `
        <p>Absolutely! Our dedicated Used Cars plan offers:</p>
        <ul style="margin-top: 10px;">
          <li>Flexible installments of up to 5 years</li>
          <li>Financing up to 15 million EGP</li>
          <li>Down payment as low as 10% (no insurance required!)</li>
          <li>Same fast approval process as new cars!</li>
        </ul>
      `,
        },
        {
          q: "Which used car brands can I finance with Contact?",
          a: `
        <p>We finance a wide selection of high-quality used cars with clear criteria to ensure value and reliability.</p>
<ul>
<li><strong>Eligible Brands:</strong>Mercedes, BMW, Skoda, Audi, Volkswagen, Jeep, Mini Cooper, Toyota, Mitsubishi, Kia, Hyundai, Nissan, Opel, Seat, Chevrolet, and Fiat</li>
<li>
You can finance cars up to 10 years old with a maximum of 150,000 km on the odometer.
</li>
</ul>
    
      `,
        },
        {
          q: "What are your financing terms for used Chinese cars?",
          a: `
        <p>We’ve made financing used Chinese cars even more affordable with a reduced down payment!</p>
        <p>All other standard conditions and benefits of our Used Cars financing plan remain unchanged, including:</p>

        <ul style="margin-top: 10px;">
          <li>No insurance required</li>
          <li>Flexible installment plans up to 5 years</li>
          <li>Financing amounts up to 15 million EGP</li>
          <li>Our simple and fast approval process</li>
        </ul>
      `,
        },
        {
          q: "Does Contact help with car license procedures?",
          a: "We’ll be with you every step of the way. To save you time and effort, our team will take care of issuing and renewing your car license and handle all needed follow-ups with the traffic authorities. All you need to do is enjoy your new car.",
        },
      ],
    },
    models: {
      title: "Explore Our Used Car Models",
      subtitle: `We offer installment plans on a wide range of high-quality used cars.
Now you can finance used cars up to 10 years old or with an odometer reading of up to 150,000 km.
Eligible used-car brands include models from the past 10 years or with up to 150,000 km:`,
      list: [
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/seat.png",
          label: "Seat",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mercedes.png",
          label: "Mercedes",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bmw.png",
          label: "BMW",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/skoda.png",
          label: "Skoda",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/audi.png",
          label: "Audi",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/volkswagen.png",
          label: "Volkswagen",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/jeep.png",
          label: "Jeep",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/min-cooper.png",
          label: "Min Cooper",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/toyota.png",
          label: "Toyota",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mitsubishi.png",
          label: "Mitsubishi",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/kia.png",
          label: "Kia",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/hyundai.png",
          label: "Hyundai",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/nissan.png",
          label: "Nissan",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/opel.png",
          label: "Opel",
        },
      ],
      outro:
        "Choose your pick now Contact! Apply for Contact’s used car financing today!",
    },
    outro:
      "Our auto financing solutions are designed to help you own your dream car with ease. We understand that buying a car can be a big investment, and nowadays it is challenging more than ever, which is why we offer flexible payment options that suit your budget. Whether you’re looking for a new or used car, we have the right financing solution for you.",
    plans_title: "Installments Plans",
    plans: [
      {
        name: "Electric Vehicles",
        role: [
          "20% down payment",
          "Insurance is not required",
          "Payment plans up to 5 years",
          "Full or partial prepayment after 1 year",
        ],
      },
      {
        name: "New Plus",
        role: [
          "20% down payment",
          "Insurance required",
          "Payment plans up to 5 years",
          "First installment after 3 months",
        ],
      },
      {
        name: "Economy",
        role: [
          "20% down payment",
          "Insurance is required",
          "Payment plans up to 3 years",
        ],
      },
      {
        name: "Economy Plus",
        role: [
          "20% down payment",
          "Insurance is required",
          "Payment plans up to 5 years",
          "Full or partial prepayment after 1 year",
        ],
      },
      {
        name: "Flexible",
        role: [
          "20% down payment",
          "Insurance is required",
          "Payment plans from 3 to 5 years",
          "Full or partial prepayment after 1 year",
          "Partial deferral for down-payment",
        ],
      },
      {
        name: "Flexible Plus",
        role: [
          "20% down payment",
          "Insurance is not required",
          "Payment plans up to 5 years",
          "Full or partial prepayment options",
          "Partial deferral for down-payment",
        ],
      },
      {
        name: "Used Cars Packages",
        role: [
          "20% down payment",
          "Insurance is not required",
          "Payment plans up to 5 years",
        ],
      },
      {
        name: "Corporate Packages",
        role: [
          "10% down payment",
          "Insurance is required",
          "Payment plans from 2 to 5 years",
          "Full prepayment option after one year",
        ],
      },
    ],
  },
  education: {
    id: 50,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/EducationMain.png",
      color: "#282781",
      title:
        "Earn your ticket to the future contact is present today to make that happen",
      description: `You can Apply Online Now or visit the Nearest Contact Branch.`,
    },
    price: "Financing Amount",
    main_section: {
      titleLine1: "Education",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/EducationMain.png",
      header: "Want to achieve Ultimate Educational Success",
      description: "and climb the ladder to the top? ",
      paragraph2:
        "With Contact’s education fee installments, whether you’re applying for school, university, or post-grad, we’ve got you covered through the most important phases of your educational journey. ",
      buttonText: "Apply Now",
      subtitle: "Focus on what matters most",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/supportingEdu.png",
      title: "Supporting Every Educational Journey",

      list: [
        {
          q: "Your 360° Journey Starts Here, School Fee Installments Made Easy",
          a: "As a parent, you want the best education for your child, and at Contact, we’re here to help make that possible. With flexible school fee installment plans tailored to your financial needs, you can secure your child’s future without the stress. Invest in their education today, and let us support you every step of the way.",
        },
        {
          q: "The Future Starts Today with Flexible University Fee Installments",
          a: "If you're a student aiming for top-tier private universities and world-class academic programs, Contact is here to support your journey. We offer tailored installment plans for private university fees, helping you access the education you deserve without financial stress. Focus on your future, we’ll take care of the rest.",
        },
        {
          q: "Advance Your Ambitions and Career, Postgraduate Financing with Contact",
          a: "Ready to pursue your Master’s or PhD? With Contact’s flexible financing solutions for postgraduate programs, you can take that next step with confidence. Whether you're continuing your academic journey or advancing your career, we’re here to support your ambitions. Apply today, and let Contact help you shape the future you envision.",
        },
      ],
    },
    why_product: {
      title: "Why Choose Contact for Education Financing?",
      subtitle: "",
      description: `At Contact, we’re not just easing the financial burden; we’re also shaping brighter futures. Our mission is to empower the next generation by providing smart, accessible financing solutions that turn educational dreams into reality.
        Here’s why families and students trust us:`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/whyContactEdu.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: "Access to quality education without compromise",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/hassleEduIcon.svg",
          text: "Fast and hassle-free approval process",
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",

          text: "Protection for your savings",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Flexible payment plans up to 12 months for schools, universities, and professional courses",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",

          text: "No down payment required",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",

          text: "Financing up to EGP 2 million",
        },
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What are the conditions for education fee installments from Contact?",
          a: `
          <p>Getting education financing with us is simple! Here’s what you’ll need:</p>
      <ul style="margin-top: 10px;">
        <li>Be an Egyptian citizen (we just need your national ID).</li>
        <li>Have a valid tuition invoice from your institution.</li>
        <li>That’s it! No down payments required.</li>
      </ul>
    `,
        },
        {
          q: "How do I apply for university fee financing with Contact?",
          a: `
          <p>Applying is simple, and you can do it your way!</p>
      <strong>Option 1: Apply Online</strong>
      <ul style="margin-top: 10px;">
        <li>Go to the Contact Education Financing page.</li>
        <li><strong>Fill out the short form:</strong> Just share your full name, mobile number, and national ID.</li>
        <li><strong>Get a personal callback:</strong> A Contact representative will call to confirm your details and request any supporting documents if needed.</li>
        <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
        <li><strong>Choose your payment plan:</strong> Select the installment plan that works best for you.</li>
        <li><strong>Track and pay your installments:</strong> Use <a href="https://api.whatsapp.com/send/?phone=20216177">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
      </ul>
      <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">
    Visit your nearest branch, and our team will guide you through the process!
<a href="https://contact.eg/en/our-branches">Find a branch near you</a>.
   </p>
    `,
        },
        {
          q: "Can private school fees be financed through Contact?",
          a: `
<p> Absolutely! Our Education Financing covers kindergarten through high school, and includes:</p>
      <ul>
        <li>All private and international schools in Egypt.</li>
        <li>Tuition fees up to EGP 2 million.</li>
        <li>School fee installments up to 12 months.</li>
      </ul>
      With fast approvals and zero down payments!
    `,
        },
        {
          q: "What documents are required for education fee installments?",
          a: `
<p>Gathering your education loan documents is simple! Here’s all you’ll need:</p>
          <ul>
        <li><strong>Your Egyptian ID:</strong> National ID card or passport.</li>
        <li><strong>The official tuition invoice:</strong> From your school/university (showing fees owed).</li>
        <li><strong>Proof of income:</strong> Salary slips for employees and bank statements for freelancers.</li>
      </ul>
    <p>Our team may request additional information depending on the type of installment. <a href="https://contact.eg/en/contact-us">Feel free to contact us</a>, we’re happy to guide you through the exact requirements and next steps!</p>
    `,
        },
        {
          q: "Does education financing cover Master's and PhD programs?",
          a: `
    <p>Yes! With Contact, you can easily finance your Master’s or PhD studies. We offer repayment plans of up to <strong>3 years</strong> for a <strong>Master’s</strong> and <a>5 years</a> for a <strong>PhD</strong>.</p>
    `,
        },
        {
          q: "Can I finance professional courses or diplomas, not just full degrees?",
          a: `
Definitely! Our financing solutions are designed to support all types of education (even short programs!), so you can keep growing your skills at any stage.    `,
        },
      ],
    },

    outro:
      "At Contact, we believe in building futures. We are committed to supporting you and your family in achieving your educational goals and dreams. With our financing solutions, you can access the best education possible without compromising on quality or affordability. Don't let financial barriers stop you from pursuing your educational goals. Apply for Contact's financing programs today and start building your future.",
  },
  mortage: {
    id: 39,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mortage.png",
      title: "Ready to take the big step towards your dream home?",
      description: "You can apply online or visit the nearest Contact branch.",
    },
    price: "Unit Price",

    section_a: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "Advantages",
      body: [
        "25 Down payment",
        "Financing up to 6 million EGP.",
        "Payment plans up to 10 years",
        "Financing all types of Residential units (standalone and compound units)",
      ],
    },
    section_b: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "Mortgage Benefits",
      body: [
        "25 Down payment",
        "Financing up to 6 million EGP.",
        "Payment plans up to 10 years",
        "Financing all types of Residential units (standalone and compound units)",
      ],
    },
    card_section_title: "Programs",
    cards: [
      {
        name: "Economy",
        role: [
          "No down payment",
          "Financing up to 6 million EGP.",
          "Payment plans from 1 to 5 years",
        ],
      },
      {
        name: "Flexible",
        role: [
          "No down payment",
          "Financing up to 6 million EGP.",
          "Payment plans from 1 to 5 years",
          "The possibility of full or partial prepayment expenses",
        ],
      },
    ],
    home_equity: {
      title: "Home Equity",
      description:
        "If you are looking for a flexible and convenient way to access funds for your personal or business needs, you may want to consider the Home Equity program from Contact. This program finances up to 75% of the current market value of your home, using your home as collateral. You can use the funds for your home improvement, debt consolidation, education, or investment. ",
      outro: {
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
        content:
          "The Home Equity program from Contact is a smart and convenient way to leverage the value of your home and achieve your financial objectives. Contact us today to find out more and get started.",
      },
    },
    home_finance: {
      title: "Home Finance",
      description:
        "Home Finance is more than just a mortgage program. It's a way to make your dreams come true. Imagine living in your own home, in the location of your choice, with all the amenities and facilities you need, having the peace of mind that comes with knowing that you have made a smart investment for your future.",
      outro: {
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mortgage-section.webp",
        content:
          "Don't wait any longer. Contact us today and find out how to finance your dream home with the easiest and fastest procedures, from Contact Mortgage.",
      },
    },
    main_section: {
      titleLine1: "Mortgage",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mortage.png",
      header: " Move In With Contact’s Property Financing Solution",
      description: "",
      paragraph2:
        "Turn your dream home into a reality with Contact’s Real Estate Financing and Home Loan solutions all under one roof. Whether you're buying your first apartment, investing in property, or searching for Mortgage Financing in Egypt, Contact has you covered.",
      buttonText: "Apply online today",
      subtitle:
        "Take the first step toward owning the home you've always dreamed of.",
    },

    product_program_1: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/second-section-mortage.png",
      title: " Home Financing In Egypt",
      paragraph: `Ready to Make the Right Move?
Whether you're searching for your dream apartment or a luxury villa, Contact Mortgage is here to make homeownership in Egypt easier than ever. With flexible solutions tailored to your lifestyle, we help you buy property in Egypt on your terms, whether through apartment financing, a villa loan, or even by estimating your payments with our real estate loan calculator.
 <a href="#apply-form" style="color: inherit; text-decoration: underline;"> Apply online</a> or visit the nearest <a href="/our-branches" style="color: inherit; text-decoration: underline;">Contact Branch</a>, and we’ll take it from here. 
`,
      list: [],
    },

    section_title: {
      title: "Villa Loan Made Easy with Contact",
      description: `Dreaming of a villa that fits your lifestyle and budget? With Contact, moving into your perfect home is simpler than ever.
We’re here to make the process smooth and stress-free, giving you and your family the space, comfort, and quality of life you truly deserve.`,
    },

    product_program_2: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fourth-section-mortage.png",
      title: "Home Equity Program by Contact",
      paragraph: `Looking for a flexible and convenient way to access funds for personal or business needs? With Contact’s Home Equity Program, you can finance up to 75% of your property's current market value, using your home as collateral, without selling. 
Whether you're planning home improvements, debt consolidation, education, or investment, we’ve got you covered.
<p style="color: inherit; font-weight: 700; margin:0;">Program Highlights:</p>
  <ul style="margin-top: -30px; padding-left: 10px;">
    <li style="margin-top: -5px;">Payment Plans up to 7 Years</li>
    <li style="margin-top: -10px;">Financing up to 15 Million EGP</li>
    <li style="margin-top: -10px;">No Down Payment Required</li>
    <li style="margin-top: -10px;">Available for All Residential Units, inside or outside compounds across Egypt.</li>
  </ul>
 <p style="color: inherit; margin-top:-50px"> <a href="#apply-form" style="color: inherit; text-decoration: underline;"> Apply online</a> or visit the nearest <a href="/our-branches" style="color: inherit; text-decoration: underline;">Contact Branch</a> to take control of your finances with confidence, flexibility, and ease.</p>`,
      list: [],
    },

    why_product: {
      title: "Own your Business Space with Contact’s Commercial Units",
      description:
        "At Contact, we help businesses unlock new opportunities with tailored commercial mortgage financing. Whether you’re purchasing a clinic, shop or an office space, for your own project or as investment. we provide competitive rates, flexible terms, and financing solutions designed around your needs. With us, you can focus on growth while we help you secure the space your business deserves.",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mortage-restaurant.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",
          text: "25% down payment",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "Financing up to 15 million EGP",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Payment plans for up to 10 years.",
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/HomeIcon.svg",
          text: "Financing all types of Commercial units (Clinics, shops, office spaces)",
        },
      ],
    },

    why_contact: {
      title: "Why Choose Contact for Your Home Loan?",
      subtitle: `Contact Mortgage, smart solutions to achieve your homeownership goals.`,
      description:
        "Make your dream home a reality with financing that fits your needs:",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Financing1.svg",
          text: "Apartment Financing & Villa Loans",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-white-icon.svg",
          text: "Financing up to 15 Million EGP",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: "Payment Plans up to 10 Years",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Analytics.svg",
          text: "Only 25% Down Payment",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Pocedures.svg",
          text: "Simple & Fast Procedures",
        },
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "How can I apply for real estate financing with Contact?",
          a: `
      <p>Applying is simple, and you can do it your way!</p>
    <strong>Option 1: Apply Online</strong>
    <ul style="margin-top: 10px;">
      <li>Go to the Contact Mortgage Financing page.</li>
      <li><strong>Fill out a short form:</strong> Just share your full name, mobile number, and national ID.</li>
      <li><strong>Get a personal callback:</strong> A Contact rep will call to confirm your details and request any supporting documents if needed.</li>
      <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
      <li><strong>Choose your payment plan: </strong>Select the installment plan that works best for you.</li>
      <li><stron>Track and pay your installments: </stron> Use <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
    </ul>
    <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">Visit your nearest branch, and our team will guide you through the process! <a href="https://contact.eg/en/our-branches">Find a branch near you.</a></p>`,
        },

        {
          q: "What types of real estate properties can I finance with Contact?",
          a: `
          <p>You can finance a wide range of homes, including<strong> apartments, villas,</strong> and residential
          <strong>units inside or outside gated communities.</strong>Whether it’s your first home or an upgrade, Contact makes property financing simple and flexible.</p>
           `,
        },

        {
          q: "What is the Home Equity program from Contact?",
          a: `
          <p>Our<strong> Home Equity </strong> program allows you to unlock the value of a home you already own and borrow up to
          <strong>75% </strong>of its current market value (with no down payment!). It’s a smart and flexible way to access extra financing from your property in Egypt.</p>
           `,
        },

        {
          q: "Why should I choose Contact for real estate financing in Egypt?",
          a: `
<p>We make buying property in Egypt simpler and more flexible. Here’s how:</p>
          <ul style="margin-top: 10px;">
      <li>Financing up to<strong> EGP 10 million</strong></li>
      <li>Payment plans of up to<strong> 10 years</strong></li>
      <li>Only<strong> 25% down payment </strong> to get started</li>
      <li><strong>Fast approvals</strong> with <strong> minimal paperwork</strong></li>
      <li>Available for<strong> all types of homes: </strong> apartments, villas, and more</li>
    </ul>
    <p>It’s a straightforward way to secure your dream home with less stress!</p>
  `,
        },
      ],
    },
  },
  leasing: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/leasing-cover.webp",
      color: "#4AA2A6",
      title1: "Leasing",
      title2: "Fuel Your Growth. Lease with Contact!",
      description: `Contact is a leading company in Egypt that offers financing programs for leasing various assets, from medical equipment to transportation vehicles. Whether you want to upgrade your hospital, clinic, or medical center with the latest devices and equipment, or you want to expand your fleet of passenger or commercial vehicles, Contact has the perfect plan for you.  `,
    },
    section_a: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "Contact Leasing Benefits",
      body: [
        "Efficient and transparent process",
        "Comprehensive and wide supplier network",
        "Access to world-class manufacturers",
        "Straightforward plans structured to suit your needs",
        "Positive impact on the company’s financial indicators",
        "Payment Plans from 1 year up to 5 years",
        "Down payment starting from 10% according to the asset type",
      ],
    },
    section_b: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "How It Works",
      description: `We design our solutions around the market value of the assets that your business needs to acquire, and nothing else.`,
      list: [
        [
          "Find the right asset for your business",
          "Our Partner Network covers medical and transportation asset sectors, whether new, used, or refurbished.",
          "1",
        ],
        [
          "Complete our simple application process",
          "We’ve worked hard on simplifying our process so that you know well in advance what documentation you’ll need, and we’ll give you a quick and committed response date.",
          "2",
        ],
        [
          "Choose a payment plan that suits you",
          "We will then provide you with payment plans based on the market value of your chosen asset. The plans include everything from the down-payment you’ll need to our administrative fees, without hidden charges and personal discounts.",
          "3",
        ],
      ],
    },
    outro:
      "Contact is more than just a financing company. We are your trusted ally that understand your business goals and help you achieve them. Contact us today and let us help you grow your business potential.",
  },
  green_finance: {
    id: 36,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/greenMain.png",
      color: "#92B338",
      title: "Ready to take the next step?",
      description: "You can apply online or visit the nearest Contact branch.",
    },
    price_desc: "Solar panels greenhouses – other agricultural products",
    price: "Product Price",

    main_section: {
      titleLine1: "Green Financing",
      titleLine2: "Solutions",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/greenMain.png",
      header: "Grow with a Greener Tomorrow",
      description: "",
      paragraph2:
        "Ready to stand on the greener side? With Contact’s Green Finance Solutions, you can now power your agriculture or renewable energy projects with smart, sustainable financing. Whether you're investing in clean energy or cultivating your agriculture, we're here to help you grow responsibly and profitably.",
      buttonText: "Apply Now",
      subtitle: "Think Smart",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/supportingGreen.png",
      title: "Our Green Finance Programs",
      list: [
        {
          q: "Solar Energy Systems",
          a: "Green Finance Solutions, Power Your Home with the Sun. Looking to cut electricity bills and live more sustainably? With Contact’s Green Finance Solutions, switching to solar has never been easier. We offer flexible financing options for home solar energy installments, allowing you to enjoy clean energy without the upfront cost. Go solar. Save more. Live greener, with Contact by your side. You can apply online or visit the nearest Contact branch.",
        },
        {
          q: "Modern Irrigation Systems",
          a: "Green Finance for Modern Irrigation Systems: Invest in Efficiency, Grow Sustainably. Upgrade your farming with smart, water-efficient irrigation systems, financed the smart way. With Contact’s Modern irrigation financing, you can boost crop yields, reduce water waste, and lower operational costs with zero upfront burden. Irrigate smarter. Grow greener. Let Contact help you make every drop count. You can apply online or visit the nearest Contact branch.",
        },
        {
          q: "Agricultural Greenhouses and Fishery Ponds",
          a: "Green Finance for Agricultural Greenhouses & Fishery Ponds: Think Smart for a more sustainable future. Contact is here to fuel your vision. Our tailored financing solutions enable you to invest in agricultural greenhouses and fishery ponds with ease. With Contact, there’s no financial strain, just growth. Grow smarter. Harvest more. You can apply online or visit the nearest Contact branch.",
        },
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What is meant by green finance?",
          a: `
      Green finance refers to funding options that support eco-friendly projects to preserve natural resources and minimize environmental impact.
      <br/><br/>
      Contact's Green Finance helps individuals and businesses invest in renewable energy solutions (like solar panel installations) or improve agricultural practices (like advanced irrigation systems, greenhouses, fishery ponds, and livestock farms) with flexible payment plans and quick approvals to benefit both their operations and the environment.
      `,
        },
        {
          q: "Who can benefit from Contact’s Green Finance?",
          a: `
      Green Finance is perfect for anyone looking to invest in eco-friendly and sustainable solutions.
      <br/><br/>
      Whether you're a farmer looking to upgrade your irrigation system, a business owner setting up a greenhouse, or simply someone who wants to install solar panels at home, Contact’s Green Finance makes sustainable living accessible and affordable for everyone.
      `,
        },
        {
          q: "How do I apply for green financing with Contact?",
          a: `
      To apply for Green Finance with Contact, you’ll need to provide:
      <ul style="margin-top: 10px;">
        <li><strong>Your Egyptian ID:</strong> National ID card or passport.</li>
        <li><strong>Proof of income:</strong> Salary slips for employees and bank statements for freelancers.</li>
        <li><strong>Loan Request Details:</strong>
          <ul style="margin-top: 5px;">
            <li>Financing amount needed (up to 3 million EGP)</li>
            <li>Desired installment plan duration (up to 5 years)</li>
          </ul>
        </li>
      </ul>
      Our team may request additional information depending on the type of installment.
      <br/><br/>
      Feel free to contact us — we’re happy to guide you through the exact requirements and next steps!
      `,
        },
        {
          q: "What is the process for getting solar panels installed with Contact?",
          a: `
      Applying for solar panel financing with Contact is simple, and you can do it your way!
      <br/><br/>
      <strong>Option 1: Apply Online</strong>
      <ul style="margin-top: 10px;">
        <li>Go to the Contact Green Finance page.</li>
        <li>Fill out the short form: Just share your full name, mobile number, and national ID.</li>
        <li>Get a personal callback: A Contact representative will call to confirm your details and request any supporting documents if needed.</li>
        <li>Receive fast approval: We review applications quickly to get you started as soon as possible.</li>
        <li>Choose your payment plan: Select the installment plan that works best for you.</li>
        <li>Track and pay your installments: Use <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
      </ul>
      <strong>Option 2: Apply In Person</strong>
      <p style="margin-top: 10px;">
        Visit your nearest Contact branch, and our team will guide you through the process.
        <a href="https://contact.eg/en/our-branches">Find a branch near you.</a>
      </p>
      `,
        },
      ],
    },

    why_product: {
      title: "Why Partner with Contact for Green Finance?",
      subtitle: " ",
      description: `At Contact, we don’t just finance projects, we bloom progress. we empower individuals and businesses to adopt sustainable solutions that drive long-term value and national impact.As a trusted leader in green financing, Here’s why Contact is the right partner for your green journey:`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/whyGreen.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/supportGreenIcon.svg",
          text: "Supporting Egypt’s Green Economy",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/expertise-icon.svg",
          text: "Proven Expertise",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: "Trusted Network of Certified Installers",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "Smart Savings, Long-Term Value",
        },
      ],
    },

    outro:
      "At Contact, we believe that agriculture development and renewable energy are the future of our planet and we work hard to support them through our innovative financing programs. If you are interested in Green Finance, please contact us today. We will be happy to provide you with more information and guide you through process.",
    section_a: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title1: "Through Green finance,  you can",
      title2: "get access to finance the following:",
      body: [
        "Solar Panels",
        "The Development of Irrigation Systems",
        "Greenhouses",
        "Developing And Equipping Projects of Trench Plantings And Plastic Sheets For Tunnels And Greenhouses",
        "Fishery Ponds and Equipment",
        "Poultry Farms and Equipment",
        "Livestock Farms and Equipment",
      ],
    },
  },
  insurance_page: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-cover.webp",
      color: "#282780",
      title1: "Insurance Brokerage",
      title2: "Stay secured, live insured.",
      description_indiv: `No more juggling between multiple insurance companies and policies. Contact Insurance Brokerage is a One-stop-shop for all your insurance needs whether you need to insure your project or company, with Contact you can choose the insurance benefits that suit all your needs, for both retail and corporates, through the best insurance companies and at the best packages in the Egyptian market.`,
      description_comp: `One-stop-shop for all your insurance needs whether you need to insure your project or company, with Contact you can choose the insurance benefits that suit all your needs, for organizations and corporates, through the best insurance companies and at the best packages in the Egyptian market.`,
    },
    subTitle: "Retail Insurance Products",

    section_a: [
      {
        img: "/family_insurance.svg",
        title: "Family Insurance",
        points: [
          "Medical Insurance",
          "Life Insurance",
          "Personal Accident Insurance",
          "Medical Discounts Card",
        ],
      },
      {
        img: "/home_insurance.svg",
        title: "Home Insurance",
        points: [
          "Home  Insurance",
          "Electronic  Insurance",
          "Extended Warranty for Electronics and Appliances ",
          "Key protection Insurance",
        ],
      },
      {
        img: "/car_insurance.svg",
        title: "Car Insurance",
        points: [
          "Motor Insurance",
          "Total Car Loss Insurance ",
          "Road Assist",
          "Key Replacement",
        ],
      },
      {
        img: "/travel_insurance.svg",
        title: "Business Insurance",
        points: ["SMEs Insurance"],
      },
    ],
  },
  watercraft: {
    id: 54,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-main.png",
      color: "#27A9E1",
      title: "Ready to Set Sail?",
      description: `Apply Now for watercraft financing online or visit your nearest Contact branch, our team will help you set sail on your next adventure!`,
    },
    price_desc: "Watercraft- yacht-jet Ski",
    price: "Product Price",

    main_section: {
      titleLine1: "Watercraft",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-main.png",
      header: "Sail through the Waves with Our Easy Watercraft Financing ",
      description: "",
      paragraph2: `Looking for luxury, excitement, and unforgettable moments on the water? With Contact’s watercraft financing solutions, owning your dream ride has never been easier. Whether you're cruising in a yacht, flying across the waves on a jet ski, or gearing up for kayaking, rafting, kitesurfing, parasailing, water skiing, or diving, we’ve got you covered.
We offer boat financing, jet ski financing, and affordable watercraft payment plans tailored to your lifestyle and budget. With simple watercraft financing requirements, Contact makes it easier than ever to get the water adventure you’ve always dreamed of. Dive into convenience, flexibility, and pure thrill, with Contact by your side.
`,
      buttonText: "Apply Now",
      subtitle: "Get Your Watercraft Today!",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-second.png",
      title: "Calculate Your Installments Easily with Contact",
      paragraph: `Planning your payments has never been easier! Use Contact’s online installment calculator to see your monthly payments for watercraft financing. Simply enter the amount, choose your preferred payment plan, and get instant results. Our calculator helps you make informed decisions and manage your budget with ease, so you can move forward confidently with your purchase.
Try Our Calculator Now!
Plan your installments in seconds and see how easy it is to own your boat with Contact
`,
      list: [],
    },
    third_section: {
      title: "Why Choose Contact for Boat Financing?",
      description: `With Contact, owning your dream watercraft is easier than ever. We offer flexible payment plans up to 5 years, financing of up to 15 million EGP, and down payments starting from just 20%. Our procedures are fast and simple, ensuring a hassle-free experience. Plus, we even provide financing for maintenance and repair expenses, so you can enjoy your boat or jet ski worry-free. Contact makes boat and watercraft financing convenient, affordable, and tailored to your needs.
`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/third-sec-watercraft.png",
    },

    why_product: {
      title: "",
      description: `Enjoy the benefits of flexible and easy financing that lets you buy all types of watercrafts you’ve always wanted with complete ease.`,

      imageSrc: "",

      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Payment plans up to 5 years",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "Financing up to 15 million EGP",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "Down-payments starting from 20%",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: "Financing maintenance and repair expenses",
        },
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What are the benefits of financing my watercraft with Contact?",
          a: `
        <p>Choosing Contact for your watercraft financing comes with a lot of great perks designed to get you on the water faster. You can enjoy:</p>
        <ul style="margin-top: 10px;">
          <li>Flexible watercraft payment plans stretching up to 5 years.</li>
          <li>Financing available up to 15 million EGP.</li>
          <li>Low down-payments starting from just 20%.</li>
          <li>Financing options that also cover maintenance and repair expenses.</li>
          <li>Simple and fast procedures, so you spend less time on paperwork and more time on the water!</li>
        </ul>
      `,
        },
        {
          q: "How do I apply for watercraft financing with Contact?",
          a: `
          <p>Applying is simple, and you can do it your way!</p>
      <strong>Option 1: Apply Online</strong>
      <ul style="margin-top: 10px;">
        <li>Go to the Contact Watercraft Financing page.</li>
        <li><strong>Fill out the short form:</strong> Just share your full name, mobile number, and national ID.</li>
        <li><strong>Get a personal callback:</strong> A Contact representative will call to confirm your details and request any supporting documents if needed.</li>
        <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
        <li><strong>Choose your payment plan:</strong> Select the installment plan that works best for you.</li>
        <li><strong>Track and pay your installments:</strong> Use <a href="https://api.whatsapp.com/send/?phone=20216177">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
      </ul>
      <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">
    Visit your nearest branch, and our team will guide you through the process!
<a href="https://contact.eg/en/our-branches">Find a branch near you</a>.
   </p>
    `,
        },
        {
          q: " What documents do I need to apply for watercraft financing from Contact?",
          a: `
        <p>To get started, we'll need your valid Egyptian National ID.</p>
        <p>When our representative calls you after your initial application, they will let you know if any other supporting documents are needed based on your profile. This helps us meet the watercraft financing requirements and get your application approved smoothly.</p>
      `,
        },
        {
          q: "What can I finance through Contact’s Watercraft Financing?",
          a: `
        <p>With Contact, you can finance a wide range of exciting options, including:</p>
        <ul style="margin-top: 10px;">
          <li>Yachts and Jet skis (we offer dedicated jet ski financing!)</li>
          <li>Rafting and Kayaking equipment</li>
          <li>Kitesurfing, Water skiing, and Parasailing equipment</li>
          <li>Diving gear...and much more!</li>
        </ul>
      `,
        },
        {
          q: "What are the conditions to qualify for watercraft financing from Contact?",
          a: `
          <p>You’ll need to meet these simple conditions:</p>
<ul>
<li>Be between 21 and 65 years old.</li>
<li>Hold a valid Egyptian ID.</li>
</ul>
    <p>We keep it straightforward so you can focus on your next adventure!</p>
      `,
        },
        {
          q: "What are your financing terms for used Chinese cars?",
          a: `
        <p>We’ve made financing used Chinese cars even more affordable with a reduced down payment!</p>
        <p>All other standard conditions and benefits of our Used Cars financing plan remain unchanged, including:</p>

        <ul style="margin-top: 10px;">
          <li>No insurance required</li>
          <li>Flexible installment plans up to 5 years</li>
          <li>Financing amounts up to EGP 10 million</li>
          <li>Our simple and fast approval process</li>
        </ul>
      `,
        },
        {
          q: "Does Contact help with car license procedures?",
          a: `
        <p>Absolutely, and it's on us!</p>
        <p>To save you time and hassle, we include a free-of-charge license procedure service with your auto financing. Our team can handle finalizing your car license renewal and follow-ups with the traffic authorities.</p>
      `,
        },
      ],
    },
    outro:
      "Contact us today and apply for your watercraft financing. We are ready to assist you and make your water adventure come true.",
  },
  motorcycle: {
    id: 55,

    cover: {
      color: "#DD6F5A",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/MotoFinanc.png",
      title: "Ready to hit the road and ignite your journey?",
      description: `You can apply online or visit the nearest Contact branch.`,
    },
    price_desc: "Motorcycle-Golf Car-Scooter",
    price: "Product Price",

    outro:
      "Contact offers a convenient and hassle-free way to own your dream motorcycle, scooter, golf cart, or beach buggy and all its accessories. Contact provides the largest financing amount and the easiest procedures to help you own your motorcycle in no time. ",

    main_section: {
      titleLine1: "Motorcycle",
      titleLine2: "Financing",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/MotoFinanc.png",
      header: "Crave the thrill of an open road?",
      description: "Let the wind rush past you on your terms.",
      paragraph2: `With Contact’s flexible motorcycle financing solutions, your dream ride is closer than ever. Whether you’re eyeing a brand-new bike, a used one, or the latest electric model, we’ve got you covered.
        But we don’t stop at motorcycles. We also provide financing options for Scooters, golf carts, and even beach buggies, you name it! `,
      buttonText: "Apply Now",
      subtitle: "Freedom starts here",
    },
    why_product: {
      title: "A Plan for Every Rider",
      subtitle: "Own the Ride. Rule the Road.",
      description:
        "At Contact, we make it easier than ever to finance all types of motorcycles, whether it’s a used motorcycle, scooter, or electric motorcycle. Your dream ride is just a few steps away.",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/golf.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "Financing up to 10 million EGP",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "Payment plans up to 5 years",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",
          text: "Down-payments starting from 10%",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fast-hassle-icon.svg",
          text: "Fast, hassle-free process",
        },
      ],
      note: "Financing for all types of motorcycles and electric bikes, cruisers, beach buggies, golf carts, gasoline scooters, and electric scooters.",
    },
    ProductBrands: {
      title: "Your Ride, your Choice, We Finance All Brands",
      subtitle: "Your Dream Ride, Backed by the Best.",
      description:
        " At Contact, we partner with all motorcycle brands to bring you trusted quality and unbeatable financing options, covering motorcycle electric installments and unique financing options. We also provide financing options for top brands like KYMCO, Daelim, Kawasaki, and Suzuki.",
      paragraph2:
        "From scooters to powerful road machines, whatever you dream of riding, you’ll find it here.",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/ProductBrand.png",
    },
    why_contact: {
      title: "Why Choose Contact for Your Motorcycle Loan?",
      subtitle: `Think Long-Term 
      Ride Smarter with Contact.`,
      description: `With Contact’s unique financing solutions, getting your dream motorcycle is easier and more rewarding than ever.
        Start now and let’s Get You Rolling with Contact! `,
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-white-icon.svg",
          text: "High financing value up to EGP 4 million",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: "Flexible repayment plans tailored to your needs",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/SimpleHassleIcon.svg",
          text: "A simple, hassle-free application process",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/AccessMotoIcon.svg",
          text: "Access to a wide network of trusted motorcycle showrooms",
        },
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What are the benefits of financing a motorcycle with Contact?",
          a: `
          <p>With Contact, financing your motorcycle is simple and stress-free! Here are the benefits you’ll enjoy:</p>
        <ul style="margin-top: 10px;">
          <li>Quick approvals</li>
          <li>Up to 4 million EGP in financing, whether your bike is new, used, or even imported</li>
          <li>Down payments starting from just 20%</li>
          <li>Payment plans up to 5 years so you can spread the cost comfortably</li>
          <li>Financing for all types of vehicles: motorcycles, scooters, beach buggies, golf carts, and even accessories</li>
          <li>You can also add insurance to protect your motorcycle and enjoy extra peace of mind</li>
        </ul>
      `,
        },
        {
          q: "How do I apply for motorcycle financing with Contact?",
          a: `
      <p>Applying is simple, and you can do it your way!</p>
    <strong>Option 1: Apply Online</strong>
    <ul style="margin-top: 10px;">
      <li>Go to the Contact Motorcycle Financing page.</li>
      <li><strong>Fill out a short form:</strong> Just share your full name, mobile number, and national ID.</li>
      <li><strong>Get a personal callback:</strong> A Contact rep will call to confirm your details and request any supporting documents if needed.</li>
      <li><strong>Receive fast approval:</strong> We review applications quickly to get you started as soon as possible.</li>
      <li><strong>Choose your payment plan: </strong>Select the installment plan that works best for you.</li>
      <li><stron>Track and pay your installments: </stron> Use <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">WhatsApp</a> or the <a href="https://play.google.com/store/apps/details?id=eg.contact">ContactNow</a> App to manage everything from home.</li>
    </ul>
    <strong>Option 2: Apply In Person</strong>
   <p style="margin-top: 10px;">Visit your nearest branch, and our team will guide you through the process! <a href="https://contact.eg/en/our-branches">Find a branch near you.</a></p>  `,
        },

        {
          q: "What documents are needed to apply for motorcycle financing from Contact?",
          a: `
          <p>You'll only need to gather these motorcycle loan documents:</p>
    <ul style="margin-top: 10px;">
      <li><strong>Your Egyptian ID:</strong> National ID card or passport.</li>
      <li><strong>Proof of income:</strong> Salary slips for employees and bank statements for freelancers.</li>
      <li><strong>Loan Request Details:</strong>
        <ul style="margin-top: 5px;">
          <li>Desired installment plan duration (up to 5 years).</li>
          <li>Financing amount needed (up to EGP 4 million).</li>
          <li>Bike model details.</li>
        </ul>
      </li>
    </ul>
    <p>Our team may request additional information depending on the type of installment. <a href="https://contact.eg/en/contact-us">Feel free to contact us</a>, we’re happy to guide you through the exact requirements and next steps!</p>
  `,
        },
        {
          q: "What can I finance through Contact’s Motorcycle Financing?",
          a: `
<p> With Contact, you can finance much more than just motorcycles! Our financing covers:</p>
          <ul style="margin-top: 10px;">
      <li><strong>Motorcycles, scooters, mountain bikes, and bicycles</strong></li>
      <li><strong>Golf carts and beach buggies</strong></li>
      <li><strong>Two-wheelers, three-wheelers, or four-wheelers — new, used, or imported</strong></li>
      <li><strong>Accessories and add-ons for your vehicle</strong></li>
    </ul>
    <p>With financing amounts of up to <strong>EGP 4 million</strong>,  you can go for the model you want (even high-end ones!) and customize it with all the features you need.</p>
  `,
        },
      ],
    },
  },
};
